import React from 'react';

const ModalVisualizaHistoricoDacaMovimentacao = (props) => {
	const {
		transacao,
	} = props;

	return (
		<div className='col-12'>
			<div className='row'>
				<div className='col-6'>
					<strong>Item:</strong>
					<p>{transacao.daca.nome}</p>
				</div>
				<div className='col-md-6'>
					<strong>Tipo de transação:</strong>
					<p>Movimentação de estoque</p>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-6'>
					<strong>Origem:</strong>
					<p>{transacao.origem}</p>
				</div>
				<div className='col-md-6'>
					<strong>Destino:</strong>
					<p>{transacao.destino}</p>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-6'>
					<strong>Quantidade:</strong>
					<p>{transacao.quantidadeEntradaSaida}</p>
				</div>
				<div className='col-md-6'>
					<strong>Recebedor:</strong>
					<p>{transacao.recebedor}</p>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-12'>
					<strong>Data de movimentação:</strong>
					<p>{transacao.dataCadastro}</p>
				</div>
			</div>
		</div>
	);
};

export default ModalVisualizaHistoricoDacaMovimentacao;
